define([], function(isArray) {
    'use strict';
    var _ = require('../../../vendor/lodash/collection.js');
    return _.map;
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/core/src/js/util/map.js
 ** module id = 69
 ** module chunks = 0
 **/